import { render } from "./ReviewsPage.vue?vue&type=template&id=b55d38d4&scoped=true"
import script from "./ReviewsPage.vue?vue&type=script&lang=js"
export * from "./ReviewsPage.vue?vue&type=script&lang=js"

import "./ReviewsPage.vue?vue&type=style&index=0&id=b55d38d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b55d38d4"]])

export default __exports__